import { createStore } from 'vuex';
import pageTitle from './modules/pageTitle';
import auth from './modules/auth';
import notification from './modules/notification';
import user from './modules/user';

export default createStore({
  modules: {
    pageTitle,
    auth,
    notification,
    user
  },
});